
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteH as ObiOwnShipRemoteHElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-h.js';
 
 
 

 
 export const ObiOwnShipRemoteH = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-h',
   elementClass: ObiOwnShipRemoteHElement,
   events: {
     
   }
  });
 
 